import action from './action'

export default {
    getStorages() {
        return action.request('get_welcom_storages')
    }
}
